import { useAuthStore, withAuthStore } from 'context/AuthStore'
import { useResErrors } from 'hooks'
import { createContext, useEffect, useRef, useState } from 'react'
import {
  filterInitialState,
  paginationInitialState,
  progressInitialState,
  tasksInitalState
} from './constants'
import { AuthService, CarService, ReportService, SalesService } from 'lib/api'
import { ROP_CAR_CODES } from 'constants/keyStatuses'
import CsContractsService from 'lib/api/services/csContracts.service'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import {
  AllStatusesDeal,
  DEMONSTRATION,
  MISSED,
  OKTELL,
  SELECTION
} from 'constants/deals'
import { EVENT_TYPE } from 'constants/events'
import useTaskApis from '../../../hooks/useTaskApis'
import moment from 'moment'
import BonusStoreProviderManager from '../Manager/BonusProvider/BonusProvider.manager'

export const HomeStoreContext = createContext({
  homeStore: {},
  homeStoreFunc: {}
})

const HomeStoreProviderRop = props => {
  const _isMounted = useRef(true)
  const { standardCheck } = useResErrors()

  const { getEvents } = useTaskApis()
  const {
    authStore: { user }
  } = useAuthStore()

  const [loading, setLoading] = useState(false)

  const [branches, setBranches] = useState([])
  const [subdivisions, setSubdivisions] = useState([])
  const [statuses, setStatuses] = useState([])
  const [managers, setManagers] = useState([])
  const [marks, setMarks] = useState([])
  const [models, setModels] = useState([])
  const [seoList, setSeoList] = useState([])
  const [statusesCount, setStatusesCount] = useState([])
  const [listDepartments, setListDepartments] = useState([])
  const [listManagers, setListManagers] = useState([])
  const [selectedTabTable, setSelectedTabTable] = useState(0)
  const [selectedMng, setSelectedMng] = useState(null)
  const [selectedBranch, setSelectedBranch] = useState(user?.data?.branch?.code)
  const [selectedSubdivision, setSelectedSubdivision] = useState(null)
  const [wlCount, setWlCount] = useState(0)
  const [wlList, setWlList] = useState([])
  const [wlFilter, setWlFilter] = useState(filterInitialState)
  const [wlTab, setWlTab] = useState(0)

  const [approveStatus, setApproveStatus] = useState('90')
  const [ropStatistics, setRopStatistics] = useState(null)
  const [ropTab, setRopTab] = useState(0)

  const [progress, setProgress] = useState(progressInitialState)
  const [pagination, setPagination] = useState(paginationInitialState)

  const [tasks, setTasks] = useState([])
  const [tasksFilter, setTasksFilter] = useState(tasksInitalState)
  const [tasksPagination, setTasksPagination] = useState(paginationInitialState)
  const [tasksCount, setTasksCount] = useState(0)

  const getWlData = () => {
    const codes = wlFilter?.statusCodes.filter(
      v => ![DEMONSTRATION, SELECTION].includes(v)
    )

    const data = {
      globalId: wlFilter.id ? Number(wlFilter.id) : undefined,
      contactId: wlFilter.contactId || undefined,
      eventId: wlFilter.eventId || undefined,
      statusCodes: codes.length ? codes : undefined,

      managers: selectedMng
        ? [selectedMng]
        : 0 < wlFilter.managers.length
        ? wlFilter.managers
        : undefined,

      branchCodes: wlFilter.branchCode
        ? [wlFilter.branchCode]
        : selectedBranch
        ? [selectedBranch]
        : undefined,
      subdivision: selectedSubdivision?.name || undefined,

      saleType: wlFilter.saleType || undefined,
      paymentType: wlFilter.paymentType || undefined,

      creationType:
        0 < wlFilter.creationType.length ? wlFilter.creationType : undefined,

      callResult: wlFilter.oktellStatus || undefined,
      isRedirect: wlFilter.trade || undefined,
      carst: wlFilter.carst || undefined,

      ropCheck: wlFilter.ropCheck
        ? true
        : wlFilter.ropCheckFalse
        ? false
        : undefined,

      car:
        !!wlFilter.vin || !!wlFilter.marka
          ? {
              vin: wlFilter.vin || undefined,
              marka: wlFilter.marka?.name || undefined,
              model: wlFilter.model?.name || undefined
            }
          : undefined,

      client:
        !!wlFilter.phoneNumber ||
        !!wlFilter.firstName ||
        !!wlFilter.lastName ||
        !!wlFilter.iin
          ? {
              phoneNumber: wlFilter.phoneNumber || undefined,
              firstName: wlFilter.firstName || undefined,
              lastName: wlFilter.lastName || undefined,
              iin: wlFilter.iin || undefined
            }
          : undefined,
      seoIdIsNull: !wlFilter.seoIdIsNull
        ? undefined
        : wlFilter.seoIdIsNull === '1'
    }

    data[`${wlFilter.dateType}DateFrom`] = wlFilter.dateFrom
      ? moment(wlFilter.dateFrom).format('YYYY-MM-DD')
      : undefined

    data[`${wlFilter.dateType}DateTo`] = wlFilter.dateTo
      ? moment(wlFilter.dateTo).format('YYYY-MM-DD')
      : undefined

    switch (wlTab) {
      case 1:
        data.statusCodes = undefined

        if (approveStatus === '80') {
          data.closedByRop = false
          data.statusCodes = [MISSED]
        }

        break

      case 2:
        data.statusCodes = [OKTELL]
        break

      case 3:
        data.statusCodes = [MISSED]
        break

      default:
    }

    return data
  }

  const getWlList = async () => {
    setLoading(true)

    await getSaleList(
      getWlData(),
      pagination.limit,
      pagination.offset ? pagination.offset - 1 : 0
    )

    setLoading(false)
  }

  const getRopStatistics = async (branch, subdivision = null) => {
    const params = {
      branch,
      subdivision,
      assignTo: selectedMng || undefined
    }
    await SalesService.getRopStatistics(params).then(res =>
      standardCheck(res, ({ data }) => {
        if (data) {
          data?.progressOnWL?.list?.forEach(e => {
            if (e?.code === ROP_CAR_CODES.car_selection_2) {
              setProgress(prevState => ({
                ...prevState,
                carSelectionCount: e.count
              }))
            }

            if (e?.code === ROP_CAR_CODES.demonstration) {
              setProgress(prevState => ({
                ...prevState,
                demonstrationCount: e.count
              }))
            }

            if (e?.code === ROP_CAR_CODES.car_selection) {
              setProgress(prevState => ({
                ...prevState,
                carSelectionCount2: e.count
              }))
            }
          })
          setRopStatistics(data)
        }
      })
    )
  }
  const getSaleList = async (data, limit, offset) => {
    const { getList, getSalesDiscount } = SalesService

    const getIt =
      wlTab === 1 && approveStatus === '90' ? getSalesDiscount : getList

    let myData = data

    if (wlTab === 2) {
      myData = {
        ...data,
        creationType: ['oktell'],
        statusCodes: undefined,
        notAssigned: true
      }
    }

    if (wlTab === 4) {
      myData = {
        ...data,
        creationType: ['smm'],
        statusCodes: undefined,
        notAssigned: true
      }
    }

    await getIt(myData, limit, offset * limit).then(response =>
      standardCheck(
        response,
        ({ data }) => {
          if (data?.listSales) {
            setWlList(data.listSales)
            setWlCount(data.countFiltered)
            setPagination(prevState => ({
              ...prevState,
              count: Math.ceil(data.countFiltered / prevState.limit)
            }))
          }
        },
        {
          onFail: () => {
            setWlList([])
            setWlCount(0)
            setPagination(prevState => ({
              ...prevState,
              offset: 0,
              count: 0
            }))
          }
        }
      )
    )
  }

  const handleFilterChange = event => {
    const name = event?.target?.name
    const value = event?.target?.value

    const isCheckbox = ['trade', 'ropCheck', 'carst', 'ropCheckFalse'].includes(
      name
    )

    setWlFilter(prevState => ({
      ...prevState,
      ...(name === 'ropCheck'
        ? { ropCheckFalse: false }
        : name === 'ropCheckFalse'
        ? { ropCheck: false }
        : {}),
      [name]: isCheckbox ? event.target.checked : value
    }))
  }

  const handleDateChange = (value, name) => {
    if (!value) {
      return
    }

    setWlFilter(prevState => ({
      ...prevState,
      [name]: new Date(value)
    }))
  }

  const onPaginationChange = async (_, newValue) => {
    setPagination(prevState => ({ ...prevState, offset: newValue }))

    setLoading(true)

    await getSaleList(
      getWlData(),
      pagination.limit,
      newValue ? newValue - 1 : 0
    )

    setLoading(false)
  }

  const handleClearFilter = async () => {
    setLoading(true)
    setWlFilter(filterInitialState)
    setPagination(paginationInitialState)

    const data = {
      statusCodes: AllStatusesDeal.map(c => c.code),
      managers: selectedMng ? [selectedMng] : undefined,
      branchCodes: selectedBranch ? [selectedBranch] : undefined
    }
    await getSaleList(data, pagination.limit, 0)
    setLoading(false)
  }

  const handleHomeCardClick = async status => {
    setRopTab(1)
    setLoading(true)

    const data =
      typeof status === 'number'
        ? {
            saleStatusTrackCode: status
          }
        : {
            statusCodes:
              status === 'ropCheck'
                ? AllStatusesDeal.filter(v => !v?.saleStatusTrackCode).map(
                    v => v.code
                  )
                : [status]
          }

    setWlFilter(prevState => ({
      ...prevState,
      ...data,
      ropCheck: status === 'ropCheck'
    }))

    if (status === 'ropCheck') {
      data.statusCodes = AllStatusesDeal.filter(
        v => !v?.saleStatusTrackCode
      ).map(v => v.code)
      data.ropCheck = true
    }

    await getSaleList(data, pagination.limit, 0)
    setLoading(false)
  }

  const handleTasksFilter = event => {
    const name = event?.target?.name
    const value = event?.target?.value

    const isCheckbox = ['expired', 'carPriceReconsider']?.includes(name)

    setTasksFilter(prevState => ({
      ...prevState,
      [name]: isCheckbox ? event.target.checked : value
    }))
  }

  const getTasksData = () => ({
    dealId: tasksFilter.dealId,
    completed: tasksFilter.completed !== 'open',
    managers: selectedMng ? [selectedMng] : undefined,
    branchCodes: selectedBranch ? [selectedBranch] : undefined,
    subdivision: selectedSubdivision?.name || undefined,
    title: tasksFilter.carPriceReconsider ? 'ПЕРЕОЦЕНКА АВТО!' : undefined,
    types:
      tasksFilter.statusCodes.length > 0 ? tasksFilter.statusCodes : undefined,
    expired: tasksFilter?.expired || undefined,
    endDateFrom: tasksFilter?.startDate
      ? moment(tasksFilter.startDate).format('YYYY-MM-DD')
      : undefined,
    endDateTo: tasksFilter?.endDate
      ? moment(tasksFilter.endDate).format('YYYY-MM-DD')
      : undefined,
    client:
      !!tasksFilter.phoneNumber || !!tasksFilter.firstName
        ? {
            firstName: tasksFilter.firstName,
            phoneNumber: tasksFilter.phoneNumber
          }
        : undefined
  })

  const handleClearTaskFilter = async () => {
    setTasksPagination(paginationInitialState)
    setTasksFilter(tasksInitalState)

    const data = {
      managers: selectedMng ? [selectedMng] : undefined,
      branchCodes: selectedBranch ? [selectedBranch] : undefined,
      subdivision: selectedSubdivision?.name || undefined,
      completed: false,
      types: EVENT_TYPE.map(e => e.code)
    }
    await getEvents({
      data,
      limit: tasksPagination.limit,
      offset: 0,
      onSuccess: ({ data }) => {
        if (data?.listEvents) {
          setTasks(data.listEvents)
          setTasksPagination(prevState => ({
            ...prevState,
            count: Math.ceil(data.countFiltered / prevState.limit)
          }))
        }
      }
    })
  }

  const handleTaskDateChange = (value, name) => {
    if (!value) {
      return
    }

    setTasksFilter(prevState => ({
      ...prevState,
      [name]: new Date(value).toISOString()
    }))
  }

  const getTasksList = async (clearPagination = false) => {
    if (clearPagination) {
      setTasksPagination(prevState => ({
        ...prevState,
        offset: 0
      }))
    }

    getEvents({
      data: getTasksData(),
      limit: tasksPagination.limit,
      offset: clearPagination ? 0 : tasksPagination.offset,
      onSuccess: ({ data }) => {
        setTasks(data?.listEvents || [])
        setTasksPagination(prevState => ({
          ...prevState,
          count: Math.ceil(data.countFiltered / prevState.limit)
        }))
        setTasksCount({ [tasksFilter.completed]: data?.countFiltered })
      }
    })
  }

  const onTasksPaginationChange = (e, newValue) => {
    setTasksPagination(prevState => ({ ...prevState, offset: newValue }))

    getEvents({
      data: getTasksData(),
      limit: tasksPagination.limit,
      offset: newValue ? newValue - 1 : 0,
      onSuccess: ({ data }) => {
        setTasks(data?.listEvents || [])
        setTasksPagination(prevState => ({
          ...prevState,
          count: Math.ceil(data.countFiltered / prevState.limit)
        }))
      }
    })
  }

  const getSeoList = async () => {
    const manager = managers.find(v => v.username === selectedMng)
    setLoading(true)
    await ReportService.getSeoList({
      branchCode: selectedBranch,
      managerFirstName: manager?.firstName || undefined,
      managerLastName: manager?.lastName || undefined
    }).then(r =>
      standardCheck(
        r,
        () => {
          setSeoList(r.data)
        },
        {
          onFail: () => setSeoList([])
        }
      )
    )
    setLoading(false)
  }

  const getStatusesCount = async (branch, subdivision = null) => {
    setLoading(true)
    const params = {
      branch: branch,
      subdivision: subdivision || undefined,
      assignTo: selectedMng || undefined
    }
    await SalesService.getStatusesCount(params).then(r =>
      standardCheck(
        r,
        () => {
          setStatusesCount(r.data)
        },
        {
          onFail: () => setStatusesCount([])
        }
      )
    )
    setLoading(false)
  }

  const getListDepartments = async () => {
    const manager = managers.find(v => v.username === selectedMng)
    setLoading(true)
    await ReportService.getListDepartments({
      branchCode: selectedBranch,
      firstName: manager?.firstName || undefined,
      lastName: manager?.lastName || undefined
    }).then(r =>
      standardCheck(
        r,
        () => {
          setListDepartments(r.data)
        },
        {
          onFail: () => setListDepartments([])
        }
      )
    )
    setLoading(false)
  }
  const getListManagers = async () => {
    setLoading(true)
    const manager = managers.find(v => v.username === selectedMng)
    await ReportService.getListManagers({
      branchCode: selectedBranch || undefined,
      subdivision: selectedSubdivision?.code || undefined,
      managerFirstName: manager?.firstName || undefined,
      managerLastName: manager?.lastName || undefined
    }).then(r =>
      standardCheck(
        r,
        () => {
          setListManagers(r.data)
        },
        {
          onFail: () => setListManagers([])
        }
      )
    )
    setLoading(false)
  }

  useEffect(() => {
    if (ropTab === 0) {
      getRopStatistics(selectedBranch, selectedSubdivision?.name)
      getStatusesCount(selectedBranch, selectedSubdivision?.name)
    }
  }, [selectedBranch, selectedSubdivision])

  useEffect(() => {
    AuthService.getBranches().then(res =>
      standardCheck(res, () => {
        if (res?.data) {
          setBranches(res.data.filter(b => user.branchList.includes(b.code)))
        }
      })
    )

    CsContractsService.getStatuses().then(res =>
      standardCheck(res, () => {
        if (res?.data) {
          setStatuses(res.data)
        }
      })
    )

    CarService.getBrands().then(res =>
      standardCheck(res, () => {
        if (res?.data) {
          setMarks(res.data)
        }
      })
    )

    return () => {
      _isMounted.current = false
      setRopStatistics(null)
    }
  }, [])

  useEffect(() => {
    if (selectedBranch) {
      setSelectedSubdivision(null)
      getSubdivisions()
    }
  }, [selectedBranch])

  useEffect(() => {
    if (selectedBranch || selectedSubdivision) {
      getManagers()
    }
  }, [selectedBranch, selectedSubdivision])

  const getSubdivisions = async () => {
    await AuthService.getSubdivisions(selectedBranch).then(res =>
      standardCheck(res, () => {
        if (res?.data) {
          setSubdivisions(res.data)
          setSelectedMng(null)
        }
      })
    )
  }

  useEffect(() => {
    if (ropTab === 0) {
      getLists()
    }
  }, [selectedTabTable, selectedBranch, selectedSubdivision, selectedMng])

  const getLists = async () => {
    if (selectedTabTable === 0) {
      await getSeoList()
      await getListDepartments()
    } else if (selectedTabTable === 1) {
      await getListManagers()
    } else {
      await getSeoList()
    }
  }

  useEffect(() => {
    if ([1, 4].includes(ropTab)) {
      setPagination(paginationInitialState)
      setLoading(true)
      setWlList([])
      setWlCount(0)
      getSaleList(getWlData(), pagination.limit, 0)
      setLoading(false)
    }
  }, [ropTab, wlTab, approveStatus])

  useEffect(() => {
    setWlFilter(prevState => ({
      ...prevState,
      model: undefined
    }))

    if (wlFilter.marka?.name) {
      CarService.getRuModels(wlFilter.marka.id).then(res =>
        standardCheck(res, () => {
          if (res?.data) {
            setModels(res.data)
          }
        })
      )
    }
  }, [wlFilter.marka])

  const getManagers = async () => {
    await AuthService.getUsers({
      roleCode: 'MANAGER',
      projectCode: 'CS_V2',
      isActive: true,
      offset: 0,
      limit: 100,
      userBranchCode: selectedBranch || user?.data?.branch?.code,
      subdivision: selectedSubdivision?.name || undefined
    }).then(res =>
      standardCheck(res, () => {
        if (res?.data?.userList) {
          setManagers(
            res.data.userList.map(e => ({
              ...e,
              fullName: [e.firstName, e.lastName].join(' ')
            }))
          )
        }
      })
    )
  }

  const returnContextByTab = () => {
    if (ropTab === 3) {
      return (
        <BonusStoreProviderManager homePrData={{ homeStore, homeStoreFunc }}>
          {props.children}
        </BonusStoreProviderManager>
      )
    }

    return props.children
  }

  const homeStore = {
    loading,
    pagination,
    progress,

    approveStatus,
    branches,

    statuses,
    subdivisions,
    managers,
    marks,
    models,

    wlList,
    wlFilter,
    wlCount,
    wlTab,
    selectedBranch,
    selectedSubdivision,
    selectedMng,

    tasks,
    tasksCount,
    tasksFilter,
    tasksPagination,
    listDepartments,
    ropStatistics,
    ropTab,
    seoList,
    statusesCount,
    listManagers,
    selectedTabTable
  }

  const homeStoreFunc = {
    getWlList,
    getTasksList,
    getSaleList,
    getSeoList,
    getListManagers,
    getListDepartments,
    setSelectedTabTable,

    handleFilterChange,
    handleDateChange,
    handleClearFilter,
    handleHomeCardClick,
    handleTasksFilter,
    handleTaskDateChange,
    handleClearTaskFilter,

    onPaginationChange,
    onTasksPaginationChange,

    setLoading,
    setWlTab,
    setTasksFilter,
    setRopTab,
    setApproveStatus,
    setSelectedMng,
    setSelectedBranch,
    setSelectedSubdivision
  }

  return (
    <HomeStoreContext.Provider value={{ homeStore, homeStoreFunc }}>
      {returnContextByTab()}

      <LoaderBackdrop loading={loading} />
    </HomeStoreContext.Provider>
  )
}

export default withAuthStore(HomeStoreProviderRop)
